export default "__VITE_ASSET__CatDZMU1__"